
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { GoogleMapsLoaderService } from '../services/google-maps/google-maps-loader.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderResolver implements Resolve<void> {
  constructor(private googleMapsLoader: GoogleMapsLoaderService) { }
  resolve(): Promise<void> {
    return this.googleMapsLoader.load(environment.googleMapsApiKey);
  }
}